/* KENTIRA Atelier — zero external dependencies. Progressive enhancement only. */
(()=>{'use strict';document.documentElement.classList.add('js');
// Cart-clear navigation: browsers may restore the previous scroll position on reload.
// Consume the flag once on the freshly rendered empty-cart page.
const clearScrollKey='kentira-scroll-top-after-clear';
try {
 if(window.sessionStorage.getItem(clearScrollKey)==='1'){
  window.sessionStorage.removeItem(clearScrollKey);
  if('scrollRestoration' in window.history)window.history.scrollRestoration='manual';
  const toTop=()=>window.scrollTo({top:0,left:0,behavior:'instant'});
  toTop();
  window.addEventListener('pageshow',()=>{
   toTop();
   window.requestAnimationFrame(()=>{
    toTop();
    window.requestAnimationFrame(toTop);
   });
  },{once:true});
 }
} catch(_error) { /* Session storage can be blocked; pre-reload reset still runs. */ }
const menuButton=document.querySelector('[data-menu-button]');
const menu=document.getElementById('mobile-navigation');
if(menuButton&&menu){
 const setMenu=open=>{menu.hidden=!open;menuButton.setAttribute('aria-expanded',String(open));menuButton.setAttribute('aria-label',open?'Close menu':'Open menu')};
 menuButton.addEventListener('click',()=>setMenu(menu.hidden));
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!menu.hidden){setMenu(false);menuButton.focus()}});
 window.addEventListener('resize',()=>{if(window.innerWidth>1100)setMenu(false)});
 menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));
}
document.querySelectorAll('[data-auto-submit]').forEach(el=>el.addEventListener('change',()=>el.form&&el.form.submit()));
const productRoot=document.querySelector('[data-product-root]');
if(productRoot){
 const select=productRoot.querySelector('[data-variant-select]');const chips=Array.from(productRoot.querySelectorAll('[data-option-index]'));
 const price=productRoot.querySelector('[data-product-price]');const compare=productRoot.querySelector('[data-product-compare]');
 const add=productRoot.querySelector('.add-to-cart');const addLabel=productRoot.querySelector('[data-add-label]');
 const gallery=productRoot.querySelector('[data-gallery]');
 // One shared gallery state for thumbnail clicks, arrow buttons, variant media and swipes.
 const galleryMedia=gallery?Array.from(gallery.querySelectorAll('[data-media-id]')):[];
 let currentMediaIndex=Math.max(0,galleryMedia.findIndex(m=>!m.hidden));
 const showMedia=id=>{
  if(!gallery||!id)return;
  const index=galleryMedia.findIndex(m=>m.dataset.mediaId===String(id));
  if(index<0)return;
  currentMediaIndex=index;
  galleryMedia.forEach((m,i)=>{m.hidden=i!==index});
  gallery.querySelectorAll('[data-thumb-id]').forEach(b=>{
   const active=b.dataset.thumbId===String(id);
   b.classList.toggle('is-current',active);
   b.setAttribute('aria-pressed',String(active));
  });
  const status=gallery.querySelector('[data-gallery-status]');
  if(status)status.textContent=`Image ${index+1} of ${galleryMedia.length}`;
 };
 const stepMedia=direction=>{
  if(galleryMedia.length<2)return;
  const nextIndex=(currentMediaIndex+direction+galleryMedia.length)%galleryMedia.length;
  showMedia(galleryMedia[nextIndex].dataset.mediaId);
 };
 gallery?.querySelectorAll('[data-thumb-id]').forEach(b=>b.addEventListener('click',()=>showMedia(b.dataset.thumbId)));
 gallery?.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>stepMedia(-1));
 gallery?.querySelector('[data-gallery-next]')?.addEventListener('click',()=>stepMedia(1));
 const galleryMain=gallery?.querySelector('.product-gallery-main');
 // Use Pointer Events for touch swipes and desktop mouse dragging; vertical scrolling stays native.
 let suppressZoomUntil=0;
 const installDragNavigation=(surface,advance,ignoreControls)=>{
  if(!surface)return;
  let drag=null;
  surface.addEventListener('pointerdown',event=>{
   if(event.button!==0 || (ignoreControls && event.target.closest('button')))return;
   drag={id:event.pointerId,x:event.clientX,y:event.clientY,active:false};
  });
  surface.addEventListener('pointermove',event=>{
   if(!drag||event.pointerId!==drag.id)return;
   const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
   if(!drag.active&&Math.abs(dx)>12&&Math.abs(dx)>Math.abs(dy)*1.15){
    drag.active=true;surface.classList.add('is-dragging');
    try{surface.setPointerCapture(event.pointerId)}catch(e){}
   }
   if(drag.active&&event.pointerType==='mouse'&&event.cancelable)event.preventDefault();
  });
  surface.addEventListener('pointerup',event=>{
   if(!drag||event.pointerId!==drag.id)return;
   const dx=event.clientX-drag.x,dy=event.clientY-drag.y;
   if(Math.abs(dx)>=45&&Math.abs(dx)>Math.abs(dy)*1.15){
    suppressZoomUntil=Date.now()+500;
    advance(dx<0?1:-1);
   }
   drag=null;surface.classList.remove('is-dragging');
  });
  surface.addEventListener('pointercancel',()=>{drag=null;surface.classList.remove('is-dragging')});
  surface.addEventListener('click',event=>{
   if(Date.now()<suppressZoomUntil&&event.target.closest('[data-zoom-trigger]')){
    event.preventDefault();event.stopImmediatePropagation();
   }
  },true);
 };
 if(galleryMedia.length>1)installDragNavigation(galleryMain,stepMedia,false);

 const q=productRoot.querySelector('[data-product-quantity]');
 const quantityFeedback=productRoot.querySelector('[data-quantity-feedback]');
 const expressCheckout=productRoot.querySelector('.dynamic-checkout');
 let quantityRequest=0;
 let currentQuantityCap=Infinity;
 let currentStockHint='';
 let checkingQuantity=false;
 let quantityStockVerified=false;
 let activeVariantId=select?.value||null;
 const showProductStock=(message,isWarning=false)=>{
  if(!quantityFeedback)return;
  quantityFeedback.textContent=message;
  quantityFeedback.classList.toggle('quantity-help--warning',isWarning);
 };
 const variantLimits=(option,inCart=0)=>{
  const tracked=option?.dataset.stockTracked==='true';
  const stock=tracked?Math.max(0,Number(option.dataset.stock)||0):Infinity;
  return {cap:tracked?Math.max(0,stock-inCart):Infinity,tracked,stock};
 };
 // Purchasable variants always start at one. Only sold-out variants use zero.
 // Display remaining stock after accounting for the unsaved selection,
 // without claiming the quantity is reserved until the cart request succeeds.
 const syncProductQuantity=(customHint)=>{
  if(!q)return;
  const option=select?.selectedOptions[0];
  const available=option?.dataset.available==='true';
  const raw=q.value.trim();
  const value=Number(raw);
  const valid=raw!==''&&Number.isSafeInteger(value)&&value>=1;
  const withinStock=valid&&value<=currentQuantityCap;
  const canBuy=available&&!checkingQuantity&&currentQuantityCap>=1&&withinStock;
  const pending=valid?value:0;
  const remaining=Math.max(0,currentQuantityCap-pending);
  const liveHint=quantityStockVerified&&Number.isFinite(currentQuantityCap)
   ?`${remaining.toLocaleString()} unit${remaining===1?'':'s'} available to add to cart.`
   :currentStockHint;
  q.disabled=!available||(!checkingQuantity&&currentQuantityCap<1);
  if(add)add.disabled=!canBuy;
  if(addLabel)addLabel.textContent=!available?'Sold out':currentQuantityCap<1?'Limit reached':'Add to cart';
  // Express checkout should not submit a quantity of zero either.
  if(expressCheckout){expressCheckout.toggleAttribute('inert',!canBuy);expressCheckout.classList.toggle('is-quantity-unavailable',!canBuy);}
  if(!available)showProductStock('This variant is currently unavailable.',true);
  else if(checkingQuantity)showProductStock(currentStockHint||'Checking stock availability…');
  else if(currentQuantityCap<1)showProductStock(currentStockHint||'No additional units are available.',true);
  else if(customHint)showProductStock(customHint,true);
  else if(!valid&&raw!==''&&raw!=='0')showProductStock('Invalid quantity.',true);
  else if(!valid)showProductStock(liveHint);
  else if(!withinStock)showProductStock(`Only ${currentQuantityCap.toLocaleString()} unit${currentQuantityCap===1?'':'s'} can be selected.`,true);
  else showProductStock(liveHint);
 };
 const refreshQuantity=async()=>{
  const request=++quantityRequest;
  const option=select?.selectedOptions[0];
  if(!option)return;
  if(option.dataset.available!=='true'){
   checkingQuantity=false;currentQuantityCap=0;
   if(q)q.dataset.quantityMax='0';
   syncProductQuantity();return;
  }
  checkingQuantity=true;
  quantityStockVerified=false;
  currentStockHint='Checking stock availability…';
  currentQuantityCap=variantLimits(option,0).cap;
  syncProductQuantity();
  let inCart=0,verified=true;
  try{
   const response=await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',headers:{'Accept':'application/json'}});
   if(!response.ok)throw new Error('Cart unavailable');
   const cart=await response.json();
   inCart=(cart.items||[]).filter(item=>String(item.variant_id||item.id)===String(option.value)).reduce((sum,item)=>sum+(Number(item.quantity)||0),0);
  }catch(_error){verified=false;}
  if(request!==quantityRequest)return;
  const {cap,tracked,stock}=variantLimits(option,inCart);
  currentQuantityCap=cap;
  checkingQuantity=false;
  quantityStockVerified=tracked&&verified;
  if(q){
   q.dataset.quantityMax=Number.isFinite(cap)?String(cap):'';
   // Stock changes may make the selection invalid. Use 0 only when sold out.
   const n=Number(q.value);
   if(Number.isFinite(cap)&&cap<1)q.value='0';
   else if(Number.isFinite(cap)&&Number.isSafeInteger(n)&&n>cap)q.value=String(cap);
  }
  if(tracked){
   currentStockHint=verified?`${cap.toLocaleString()} unit${cap===1?'':'s'} available to add to cart.`:`${stock.toLocaleString()} unit${stock===1?'':'s'} in stock. Availability is verified when adding to cart.`;
  }else{
   currentStockHint='Available to order.';
  }
  syncProductQuantity();
 };
 if(q){
  q.addEventListener('input',()=>{
   const raw=q.value.trim(),value=Number(raw);
   if(raw!==''&&Number.isSafeInteger(value)&&value>currentQuantityCap&&Number.isFinite(currentQuantityCap)){
    q.value=String(Math.max(0,currentQuantityCap));
    syncProductQuantity(`Only ${currentQuantityCap.toLocaleString()} unit${currentQuantityCap===1?'':'s'} available to add to cart.`);
   }else syncProductQuantity();
  });
  q.addEventListener('blur',()=>{
   const value=Number(q.value);
   if(q.value.trim()===''||!Number.isSafeInteger(value)||value<1)
    q.value=currentQuantityCap>=1?'1':'0';
   syncProductQuantity();
  });
 }
 const updateUI=()=>{
  if(!select)return;
  const option=select.selectedOptions[0];if(!option)return;
  // Every available variant starts at 1, including after switching.
  // The selected quantity never carries across from the previous variant.
  if(activeVariantId!==option.value&&q){
   q.value=option.dataset.available==='true'?'1':'0';
   q.dataset.quantityMax='';
   quantityStockVerified=false;
  }
  activeVariantId=option.value;
  if(price)price.textContent=option.dataset.price||'';
  if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare;}
  if(option.dataset.mediaId)showMedia(option.dataset.mediaId);
  refreshQuantity();
  try{const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);}catch(e){}
 };
 const syncFromChips=()=>{
  if(!select||!chips.length)return;
  const selections=Array.from(new Set(chips.map(c=>c.dataset.optionIndex))).map(idx=>chips.find(c=>c.dataset.optionIndex===idx&&c.checked)?.value||'');
  const exact=Array.from(select.options).find(o=>{try{return JSON.stringify(JSON.parse(o.dataset.options||'[]'))===JSON.stringify(selections);}catch(e){return false;}});
  if(exact){select.value=exact.value;updateUI();}
  else{
   quantityRequest++;checkingQuantity=false;currentQuantityCap=0;
   if(q){q.value='0';q.disabled=true;}
   if(add)add.disabled=true;
   if(addLabel)addLabel.textContent='Unavailable combination';
   if(expressCheckout)expressCheckout.setAttribute('inert','');
   showProductStock('Select an available product variant.',true);
  }
 };
 chips.forEach(chip=>chip.addEventListener('change',syncFromChips));
 select?.addEventListener('change',updateUI);
 // The photo viewer uses the same original Shopify images and keeps main-gallery selection in sync.
 const dialog=document.querySelector('[data-zoom-dialog]');
 const dialogImg=dialog?.querySelector('[data-zoom-image]');
 const zoomThumbs=dialog?Array.from(dialog.querySelectorAll('[data-zoom-media-id]')):[];
 let activeZoomIndex=0,zoomOpenTrigger=null;
 const showZoom=(index)=>{
  if(!dialogImg||!zoomThumbs.length)return;
  activeZoomIndex=(index+zoomThumbs.length)%zoomThumbs.length;
  const thumb=zoomThumbs[activeZoomIndex];
  const img=thumb.querySelector('img');
  dialogImg.src=thumb.dataset.zoomSrc||img?.src||'';
  dialogImg.alt=img?.alt||`Product photo ${activeZoomIndex+1}`;
  zoomThumbs.forEach((b,i)=>{
   const active=i===activeZoomIndex;
   b.classList.toggle('is-current',active);
   b.setAttribute('aria-pressed',String(active));
  });
  dialog.querySelector('[data-zoom-status]')?.replaceChildren(document.createTextNode(`Photo ${activeZoomIndex+1} of ${zoomThumbs.length}`));
  thumb.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
  showMedia(thumb.dataset.zoomMediaId);
 };
 const stepZoom=(direction)=>showZoom(activeZoomIndex+direction);
 gallery?.querySelectorAll('[data-zoom-trigger]').forEach(button=>button.addEventListener('click',()=>{
  if(!dialog||!dialogImg||typeof dialog.showModal!=='function')return;
  const parent=button.closest('[data-media-id]');
  const matching=zoomThumbs.findIndex(t=>t.dataset.zoomMediaId===parent?.dataset.mediaId);
  zoomOpenTrigger=button;
  if(matching>=0)showZoom(matching);
  else{const img=button.querySelector('img');dialogImg.src=button.dataset.zoomSrc||img?.currentSrc||img?.src||'';dialogImg.alt=img?.alt||'Enlarged product photo';}
  dialog.showModal();
 }));
 zoomThumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>showZoom(index)));
 dialog?.querySelector('[data-zoom-prev]')?.addEventListener('click',()=>stepZoom(-1));
 dialog?.querySelector('[data-zoom-next]')?.addEventListener('click',()=>stepZoom(1));
 if(zoomThumbs.length>1)installDragNavigation(dialog?.querySelector('[data-zoom-stage]'),stepZoom,true);
 dialog?.addEventListener('keydown',event=>{
  if(event.key==='ArrowRight'){event.preventDefault();stepZoom(1)}
  if(event.key==='ArrowLeft'){event.preventDefault();stepZoom(-1)}
 });
 dialog?.querySelector('[data-zoom-close]')?.addEventListener('click',()=>dialog.close());
 dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
 dialog?.addEventListener('close',()=>{if(zoomOpenTrigger?.isConnected)zoomOpenTrigger.focus({preventScroll:true});zoomOpenTrigger=null});


 // Add-to-cart remains on the product page. Only the regular Add to cart
 // control is intercepted; Shopify's express "Buy it now" keeps its own flow.
 const productForm=productRoot.querySelector('form.product-form');
 if(productForm){
  let adding=false;
  productForm.addEventListener('submit',async event=>{
   if(event.submitter && !event.submitter.matches('.add-to-cart'))return;
   if(adding)return event.preventDefault();
   if(!productForm.checkValidity())return;
   event.preventDefault();
   adding=true;
   const feedback=productForm.querySelector('[data-product-feedback]');
   if(feedback)feedback.textContent='';
   const originalLabel=addLabel?.textContent;
   if(add)add.disabled=true;
   if(addLabel)addLabel.textContent='Adding…';
   try{
    const option=select?.selectedOptions[0];
    const requested=Number(q?.value);
    if(!option||!Number.isSafeInteger(requested)||requested<1)
     throw new Error('Please enter a whole-number quantity of at least 1.');
    if(option.dataset.available!=='true')throw new Error('This variant is sold out.');
    // Recheck the current cart immediately before adding. A second tab might
    // have changed quantities since the dropdown was last rendered.
    const cartResponse=await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',headers:{'Accept':'application/json'}});
    if(!cartResponse.ok)throw new Error('Unable to confirm current cart quantities. Please retry.');
    const currentCart=await cartResponse.json();
    const inCart=(currentCart.items||[]).filter(item=>String(item.variant_id||item.id)===String(option.value)).reduce((sum,item)=>sum+(Number(item.quantity)||0),0);
    const {cap}=variantLimits(option,inCart);
    if(requested>cap){
     refreshQuantity();
     throw new Error(cap>0?`Only ${cap} more unit${cap===1?'':'s'} can be added. Please enter a smaller quantity.`:'No additional units are available for this variant.');
    }
    const response=await fetch(cartEndpoint('cart/add.js'),{
     method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
     body:new FormData(productForm),credentials:'same-origin'
    });
    const result=await response.json().catch(()=>({}));
    if(!response.ok)throw new Error(result.description||result.message||'Could not add this item.');
    showCartToast('Added to cart',true);
    // Reset for a new purchase; refreshQuantity will clamp to 0 if sold out.
    if(q)q.value='1';
    refreshQuantity();
    try{
     const cartResponse=await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',headers:{'Accept':'application/json'}});
     if(cartResponse.ok){const cartData=await cartResponse.json();updateCartCount(cartData.item_count);}
    }catch(_error){/* Cart was added; a cart-count refresh failure must not undo it. */}
   }catch(error){
    const message=(typeof error.message==='string'&&error.message.length<200)?error.message:'Unable to add the item. Please try again.';
    showCartToast(message,false);
    if(feedback)feedback.textContent=message;
    // Shopify might have partially applied an add before returning 422.
    refreshQuantity();
    fetch(cartEndpoint('cart.js'),{credentials:'same-origin'}).then(r=>r.ok?r.json():null).then(c=>{if(c)updateCartCount(c.item_count)}).catch(()=>{});
   }finally{
    adding=false;
    syncProductQuantity();
   }
  });
 }
 updateUI();
}

// Ajax cart methods are locale aware and do not navigate away from the page.
function cartEndpoint(resource){
 const raw=window.Shopify?.routes?.root||document.body.dataset.shopifyRoot||'/';
 return (raw.endsWith('/')?raw:raw+'/')+resource;
}
function updateCartCount(count){
 if(!Number.isFinite(Number(count)))return;
 document.querySelectorAll('[data-cart-count]').forEach(badge=>{
  badge.textContent=String(count);
  badge.hidden=Number(count)===0;
 });
 document.querySelectorAll('.cart-action').forEach(link=>link.setAttribute('aria-label',`Cart, ${count} items`));
}
// KENTIRA Atelier V2.3: same notification on touch and desktop.
// Animate only the notification container, not product buttons or its child controls.
// Web Animations API avoids mobile Safari skipping CSS class transitions.
let toastHoldTimer=null;
let toastActiveAnimation=null;
let toastSerial=0;
function showCartToast(message,success){
 const toast=document.querySelector('.kt-toast');
 if(!toast)return;
 const serial=++toastSerial;
 clearTimeout(toastHoldTimer);
 if(toastActiveAnimation){toastActiveAnimation.cancel();toastActiveAnimation=null;}
 toast.hidden=true;
 toast.classList.remove('is-entering','is-visible','is-leaving');
 toast.replaceChildren();
 toast.dataset.kind=success?'success':'error';
 const info=document.createElement('p');info.className='toast-message';
 if(success){const tick=document.createElement('span');tick.className='toast-check';tick.textContent='✓';tick.setAttribute('aria-hidden','true');info.append(tick);}
 const messageSpan=document.createElement('span');messageSpan.textContent=message;info.append(messageSpan);toast.append(info);
 if(success){
  const link=document.createElement('a');link.className='toast-link';link.href=cartEndpoint('cart');link.textContent='View cart';toast.append(link);
 }
 const close=document.createElement('button');close.type='button';close.className='toast-close';close.textContent='×';close.setAttribute('aria-label','Dismiss notification');toast.append(close);
 const reducedMotion=window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
 const fadeMs=reducedMotion?0:900;
 let exiting=false;
 // Opacity is animated on the toast only. JS reuses this animation on phones
 // and desktop rather than relying on a media-query-specific CSS transition.
 const fade=(from,to)=>{
  if(!fadeMs)return Promise.resolve();
  if(typeof toast.animate==='function'){
   const animation=toast.animate([{opacity:from},{opacity:to}],{duration:fadeMs,easing:'ease-in-out',fill:'both'});
   toastActiveAnimation=animation;
   return animation.finished.catch(()=>{}).then(()=>{
    if(toastActiveAnimation===animation){
     toastActiveAnimation=null;
     animation.cancel();
    }
   });
  }
  // Fallback for older browsers without the Web Animations API.
  const phase=to===1?'is-entering':'is-leaving';
  toast.classList.remove('is-entering','is-leaving');
  toast.classList.add(phase);
  return new Promise(resolve=>setTimeout(()=>{
   toast.classList.remove(phase);
   resolve();
  },fadeMs));
 };
 const dismiss=()=>{
  if(serial!==toastSerial||toast.hidden||exiting)return;
  exiting=true;
  clearTimeout(toastHoldTimer);
  const currentOpacity=Math.min(1,Math.max(0,Number.parseFloat(getComputedStyle(toast).opacity)||1));
  if(toastActiveAnimation){toastActiveAnimation.cancel();toastActiveAnimation=null;}
  fade(currentOpacity,0).then(()=>{
   if(serial!==toastSerial)return;
   toast.hidden=true;
   toast.classList.remove('is-visible','is-entering','is-leaving');
  });
 };
 close.addEventListener('click',dismiss);
 toast.hidden=false;
 toast.classList.add('is-visible');
 fade(0,1).then(()=>{
  if(serial!==toastSerial||toast.hidden||exiting)return;
  // Five full seconds AFTER the fade-in completes.
  toastHoldTimer=setTimeout(dismiss,5000);
 });
}

// KENTIRA Atelier V3.19 — Auto-save cart quantity changes and removals.
// Use the inventory-aware cart/change.js endpoint, one request at a time.
// Prices come from Shopify's cart response and (when available) bundled section HTML.
const cartForm=document.getElementById('cart-form');
const cartFeedback=cartForm?.querySelector('[data-cart-update-feedback]');
if(cartForm){
 const checkout=cartForm.querySelector('button[name="checkout"]');
 const sectionId=cartForm.dataset.cartSectionId;
 const pendingTimers=new Map();
 let cartQueue=Promise.resolve();
 let tasks=0;
 const hideFeedback=()=>{if(cartFeedback){cartFeedback.hidden=true;cartFeedback.textContent='';cartFeedback.classList.remove('quantity-help--warning');}};
 const feedback=(message,error=false)=>{
  if(!cartFeedback)return;
  cartFeedback.hidden=false;cartFeedback.textContent=message;
  cartFeedback.classList.toggle('quantity-help--warning',error);
 };
 const syncCheckout=()=>{if(checkout)checkout.disabled=tasks>0||pendingTimers.size>0;};
 const money=(cents,currency)=>{
  const number=Number(cents)/100;
  if(!Number.isFinite(number))return '';
  try{return new Intl.NumberFormat(document.documentElement.lang||'en-US',{
   style:'currency',currency:currency||window.Shopify?.currency?.active||'USD'
  }).format(number);}catch(_error){return number.toFixed(2);}
 };
 const updateDisplay=(cart,changedInput,changeVersion,removed)=>{
  updateCartCount(cart.item_count);
  if(cart.item_count===0){
   // The existing empty-cart state is server rendered; return to the top once.
   try{window.sessionStorage.setItem(clearScrollKey,'1');}catch(_error){}
   if('scrollRestoration' in window.history)window.history.scrollRestoration='manual';
   window.scrollTo({top:0,left:0,behavior:'instant'});
   window.location.reload();return;
  }
  if(removed)changedInput.closest('.cart-row')?.remove();
  const rows=Array.from(cartForm.querySelectorAll('.cart-row'));
  if(rows.length!==cart.items.length){
   // An app/discount changed the number of lines: resync the view safely.
   window.location.reload();return;
  }
  const returnedMarkup=sectionId&&cart.sections?.[sectionId];
  const rendered=typeof returnedMarkup==='string'&&returnedMarkup.length
   ? new DOMParser().parseFromString(returnedMarkup,'text/html'):null;
  const serverRows=rendered?Array.from(rendered.querySelectorAll('.cart-row')):[];
  for(let i=0;i<rows.length;i++){
   const row=rows[i],item=cart.items[i];
   const input=row.querySelector('[data-cart-quantity]');
   if(!input)continue;
   input.dataset.lineKey=item.key;
   input.dataset.variantId=String(item.variant_id||item.id);
   input.dataset.originalQuantity=String(item.quantity);
   // Preserve newer edits made while a slower request was in flight.
   if(input===changedInput){
    input.dataset.savedVersion=String(changeVersion);
    if(Number(input.dataset.editVersion||0)===changeVersion)input.value=String(item.quantity);
   }else if(Number(input.dataset.editVersion||0)===Number(input.dataset.savedVersion||0)){
    input.value=String(item.quantity);
   }
   // Keep the per-unit price, arithmetic breakdown and displayed line total
   // consistent with Shopify's confirmed cart values (including discounts).
   const serverRow=serverRows[i];
   const formattedTotal=serverRow?.querySelector('[data-cart-line-total-value]')?.textContent?.trim()
    ||money(item.final_line_price,cart.currency);
   const formattedUnit=serverRow?.querySelector('[data-cart-unit-price-value]')?.textContent?.trim()
    ||money(item.final_price,cart.currency);
   const updateText=(selector,value)=>{const node=row.querySelector(selector);if(node)node.textContent=value;};
   updateText('[data-cart-line-total-value]',formattedTotal);
   updateText('[data-cart-unit-price-value]',formattedUnit);
   updateText('[data-cart-price-quantity]',String(item.quantity));
   updateText('[data-cart-price-unit]',formattedUnit);
   updateText('[data-cart-price-total]',formattedTotal);
  }
  const subtotal=cartForm.querySelector('.summary-row strong');
  const serverSubtotal=rendered?.querySelector('.summary-row strong');
  if(subtotal)subtotal.textContent=serverSubtotal?.textContent?.trim()||money(cart.total_price,cart.currency);
  // Recalculate the remaining-stock hint without scheduling another cart write.
  cartForm.dispatchEvent(new Event('kentira-cart-synced'));
 };
 const validate=(input,quantity,remove=false)=>{
  if(!remove&&(!Number.isSafeInteger(quantity)||quantity<1)){
   feedback('Enter a whole-number quantity of at least 1, or use Remove.',true);return false;
  }
  if(input.dataset.stockTracked==='true'&&!remove){
   const id=input.dataset.variantId;
   const all=Array.from(cartForm.querySelectorAll('[data-cart-quantity]')).filter(el=>el.dataset.variantId===id);
   const total=all.reduce((sum,el)=>sum+(el===input?quantity:Number(el.value)||0),0);
   const stock=Math.max(0,Number(input.dataset.stock)||0);
   if(total>stock){
    feedback(`Only ${stock} unit${stock===1?'':'s'} available for this variant. Please lower the quantity.`,true);return false;
   }
  }
  return true;
 };
 const save=(input,quantity,version,remove=false)=>{
  tasks++;syncCheckout();
  cartQueue=cartQueue.catch(()=>{}).then(async()=>{
   if(!input.isConnected)return;
   if(!validate(input,quantity,remove))return;
   if(quantity===Number(input.dataset.originalQuantity))return;
   feedback(remove?'Removing item…':'Saving cart…');
   try{
    const body={id:input.dataset.lineKey,quantity};
    if(sectionId){body.sections=[sectionId];body.sections_url=cartEndpoint('cart');}
    const response=await fetch(cartEndpoint('cart/change.js'),{
     method:'POST',credentials:'same-origin',
     headers:{'Content-Type':'application/json','Accept':'application/json'},
     body:JSON.stringify(body)
    });
    const result=await response.json().catch(()=>({}));
    if(!response.ok){throw new Error(typeof result.description==='string'?result.description:
     response.status===403?'Shopify restricted the cart update (403). Please check store permissions.':
     'Unable to save this change. Please try again.');}
    if(!Array.isArray(result.items))throw new Error('Shopify did not confirm the updated cart.');
    const previous=Number(input.dataset.originalQuantity);
    // Shopify may correct the quantity (e.g. stock changed in another tab).
    const rowIndex=Array.from(cartForm.querySelectorAll('.cart-row')).indexOf(input.closest('.cart-row'));
    if(!remove&&Number(result.items[rowIndex]?.quantity)!==quantity){
     throw new Error('Shopify could not save that quantity. Please refresh and check stock availability.');
    }
    updateDisplay(result,input,version,remove);
    hideFeedback();
   }catch(error){
    if(input.isConnected && Number(input.dataset.editVersion||0)===version){
     input.value=input.dataset.originalQuantity||'1';
     cartForm.dispatchEvent(new Event('kentira-cart-synced'));
    }
    feedback(error.message||'Unable to update the cart.',true);
   }
  }).finally(()=>{tasks=Math.max(0,tasks-1);syncCheckout();});
 };
 const schedule=(input,remove=false,immediate=false)=>{
  const previous=pendingTimers.get(input);
  if(previous)clearTimeout(previous);
  pendingTimers.delete(input);
  const version=Number(input.dataset.editVersion||0)+1;
  input.dataset.editVersion=String(version);
  const quantity=remove?0:Number(input.value);
  if(!remove&&(!Number.isSafeInteger(quantity)||quantity<1)){
   // Allow temporary empty input while typing, but never submit an invalid order.
   feedback('Enter a whole-number quantity of at least 1, or use Remove.',true);
   syncCheckout();return;
  }
  if(!validate(input,quantity,remove)){syncCheckout();return;}
  hideFeedback();
  const timer=setTimeout(()=>{
   pendingTimers.delete(input);
   save(input,quantity,version,remove);
   syncCheckout();
  },immediate?0:500);
  pendingTimers.set(input,timer);syncCheckout();
 };
 cartForm.addEventListener('input',event=>{
  if(!event.target.matches('[data-cart-quantity]'))return;
  schedule(event.target,false,event.detail?.step===true);
 });
 cartForm.addEventListener('change',event=>{
  if(event.target.matches('[data-cart-quantity]'))schedule(event.target,false,true);
 });
 cartForm.addEventListener('click',event=>{
  const remove=event.target.closest('[data-cart-remove]');
  if(!remove)return;
  event.preventDefault();
  const input=remove.closest('.cart-row')?.querySelector('[data-cart-quantity]');
  if(input)schedule(input,true,true);
 });
 cartForm.addEventListener('submit',event=>{
  if(event.submitter?.name!=='checkout')event.preventDefault();
  else if(tasks>0||pendingTimers.size>0){event.preventDefault();feedback('Please let the cart finish saving before checkout.',true);}
 });
}

// Custom branded confirmation dialog, rather than browser window.confirm().
// The dialog sits outside the cart's update/checkout form.
const clearCartButton=document.querySelector('[data-clear-cart]');
const clearCartDialog=document.querySelector('[data-clear-cart-dialog]');
if(clearCartButton&&clearCartDialog){
 const cancelButton=clearCartDialog.querySelector('[data-clear-cart-cancel]');
 const confirmButton=clearCartDialog.querySelector('[data-clear-cart-confirm]');
 const dialogFeedback=clearCartDialog.querySelector('[data-clear-dialog-feedback]');
 const feedback=document.querySelector('[data-cart-clear-feedback]');
 let clearing=false;
 const resetFeedback=()=>{
  if(dialogFeedback){dialogFeedback.textContent='';dialogFeedback.hidden=true;}
  if(feedback){feedback.textContent='';feedback.hidden=true;}
 };
 clearCartButton.addEventListener('click',()=>{
  if(clearing)return;
  resetFeedback();
  clearCartDialog.showModal();
 });
 cancelButton?.addEventListener('click',()=>{
  if(!clearing)clearCartDialog.close();
 });
 clearCartDialog.addEventListener('click',event=>{
  // Backdrop click closes the confirmation. Clicking its content does not.
  if(!clearing && event.target===clearCartDialog)clearCartDialog.close();
 });
 clearCartDialog.addEventListener('cancel',event=>{
  if(clearing)event.preventDefault();
 });
 clearCartDialog.addEventListener('close',()=>{
  if(!clearing&&clearCartButton.isConnected)clearCartButton.focus({preventScroll:true});
 });
 confirmButton?.addEventListener('click',async()=>{
  if(clearing)return;
  clearing=true;
  clearCartButton.disabled=true;
  confirmButton.disabled=true;
  if(cancelButton)cancelButton.disabled=true;
  const originalText=confirmButton.textContent;
  confirmButton.textContent='Removing…';
  resetFeedback();
  try{
   const response=await fetch(cartEndpoint('cart/clear.js'),{
    method:'POST',credentials:'same-origin',
    headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}
   });
   if(!response.ok){const payload=await response.json().catch(()=>({}));throw new Error(payload.description||'Unable to clear your cart.');}
   const data=await response.json();
   if(Number(data.item_count)!==0)throw new Error('Cart could not be cleared. Please try again.');
   updateCartCount(0);
   // Mark the reload to disable browser scroll restoration only for this action.
   try{window.sessionStorage.setItem(clearScrollKey,'1');}catch(_error){}
   if('scrollRestoration' in window.history)window.history.scrollRestoration='manual';
   window.scrollTo({top:0,left:0,behavior:'instant'});
   window.location.reload();
  }catch(error){
   const message=error.message||'Unable to clear your cart. Please try again.';
   if(dialogFeedback){dialogFeedback.textContent=message;dialogFeedback.hidden=false;}
   if(feedback){feedback.textContent=message;feedback.hidden=false;}
   clearCartButton.disabled=false;
   confirmButton.disabled=false;
   if(cancelButton)cancelButton.disabled=false;
   confirmButton.textContent=originalText;
   clearing=false;
  }
 });
}
})();

// V3.3: keyboard-friendly typed quantities and stationary + / − buttons.
// Do not impose a made-up 20-unit cap on Shopify inventory.
document.querySelectorAll('[data-quantity-control]').forEach(control=>{
 const input=control.querySelector('input[type="number"]');
 if(!input)return;
 const getLimit=()=>{
  if(input.matches('[data-product-quantity]')){
   const max=input.dataset.quantityMax;return max?Number(max):Infinity;
  }
  const id=input.dataset.variantId;
  const siblingInputs=Array.from(document.querySelectorAll('[data-cart-quantity]')).filter(el=>el!==input&&el.dataset.variantId===id);
  const otherQty=siblingInputs.reduce((sum,el)=>sum+(Number(el.value)||0),0);
  return input.dataset.stockTracked==='true'?Math.max(0,Number(input.dataset.stock)-otherQty):Infinity;
 };
 const notifyLimit=limit=>{
  const text=Number.isFinite(limit)?`Only ${Math.max(0,limit)} unit${limit===1?'':'s'} can be selected for this line, based on available stock.`:'Enter a valid quantity.';
  if(input.matches('[data-product-quantity]')){
   const msg=document.querySelector('[data-quantity-feedback]');if(msg){msg.textContent=text;msg.classList.add('quantity-help--warning');}
  }else{
   const feedback=document.querySelector('[data-cart-update-feedback]');if(feedback){feedback.hidden=false;feedback.textContent=text;}
  }
 };
 control.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{
  if(input.disabled)return;
  const direction=Number(button.dataset.quantityStep);
  const value=Number(input.value);
  const isProduct=input.matches('[data-product-quantity]');
  const minimum=1;
  const current=Number.isSafeInteger(value)&&value>=1?value:0;
  // From an empty field, + selects 1 (not 2); - never goes below 1.
  const next=Math.max(minimum,current+direction);
  const limit=getLimit();
  if(next>limit){notifyLimit(limit);return;}
  input.value=String(next);
  input.dispatchEvent(new CustomEvent('input',{bubbles:true,detail:{step:true}}));
 }));
});


// V3.6 — immediately recalculate remaining-to-add quantities in the cart.
// Cart inputs represent a proposed cart until "Update cart" is clicked.
// This number is a live estimate, NOT a Shopify inventory reservation.
// Shopify /cart/change.js still validates the actual quantities on save.
(()=>{
 const inputs=Array.from(document.querySelectorAll('#cart-form [data-cart-quantity]'));
 if(!inputs.length)return;
 const byVariant=new Map();
 for(const input of inputs){
  const id=input.dataset.variantId;
  if(!byVariant.has(id))byVariant.set(id,[]);
  byVariant.get(id).push(input);
 }
 const updateAvailability=()=>{
  for(const group of byVariant.values()){
   const tracked=group.some(input=>input.dataset.stockTracked==='true');
   const stock=Math.max(0,Number(group[0].dataset.stock)||0);
   const counts=group.map(input=>Number(input.value));
   const valid=group.every((input,index)=>input.value.trim()!==''&&Number.isSafeInteger(counts[index])&&counts[index]>=1);
   const requested=valid?counts.reduce((sum,n)=>sum+n,0):0;
   const remaining=Math.max(0,stock-requested);
   let message;
   let warning=false;
   if(!tracked){message='Available to order.';}
   else if(!valid){message='Enter a valid whole-number quantity.';warning=true;}
   else if(requested>stock){
    message=`Only ${stock.toLocaleString()} unit${stock===1?'':'s'} available for this variant. Please reduce your quantity.`;
    warning=true;
   }else{
    message=`${remaining.toLocaleString()} unit${remaining===1?'':'s'} available to add to cart.`;
   }
   for(const input of group){
    const hint=input.closest('.cart-row')?.querySelector('[data-line-stock-text]');
    if(!hint)continue;
    hint.textContent=message;
    hint.classList.toggle('quantity-help--warning',warning);
   }
  }
 };
 // +/- controls dispatch bubbling `input`; typed values use the same handler.
 inputs.forEach(input=>{
  input.addEventListener('input',updateAvailability);
  input.addEventListener('change',updateAvailability);
 });
 document.getElementById('cart-form')?.addEventListener('kentira-cart-synced',updateAvailability);
 updateAvailability();
})();
